const STORAGE_KEY = '@wazir:barid_agent_enabled';
const DEVICE_KEY = '@wazir:barid_local_device_id';

/**
 * "Habilitar o Barid neste computador": a FONTE DE VERDADE e o servidor (`barid_devices.config.agentEnabled`
 * do terminal deste computador, gravado por tela com `PUT barid-devices/:id/config`), assim a escolha
 * sobrevive a troca de navegador, usuario, atualizacao e formatacao. Este arquivo guarda so um CACHE no
 * navegador, para a tela nao consultar o agente enquanto o servidor ainda nao respondeu.
 * Ausente (ou storage bloqueado) = habilitado, o comportamento de hoje.
 */
export function isBaridAgentEnabled(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
}

/** Atualiza o cache (nunca e a fonte de verdade). */
export function cacheBaridAgentEnabled(enabled: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // storage bloqueado (janela privada): o cache vale so ate recarregar a tela
  }
}

/** Ultimo terminal conhecido deste computador (cache): permite ler o servidor sem consultar o agente. */
export function cachedBaridLocalDeviceId(): string | null {
  try {
    return window.localStorage.getItem(DEVICE_KEY) || null;
  } catch {
    return null;
  }
}

export function cacheBaridLocalDeviceId(id: string | null): void {
  try {
    if (id) window.localStorage.setItem(DEVICE_KEY, id);
    else window.localStorage.removeItem(DEVICE_KEY);
  } catch {
    // ignora
  }
}
